// Add custom code below this line
setInterval(function time() {
  var d = new Date();
  var d1 = new Date();
  d.setHours(d1.getHours() + 6);
  var hours = 23 - d.getHours();
  var min = 60 - d.getMinutes();
  if ((min + "").length == 1) {
    min = "0" + min;
  }
  var sec = 60 - d.getSeconds();
  if ((sec + "").length == 1) {
    sec = "0" + sec;
  }
  $(".timer").html(hours + " timer " + min + " min " + sec + " sek");

  var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  var currentDateNew = new Date(new Date().getTime() + 0 * 60 * 60 * 1000);
  var day = currentDateNew.getDate();
  let dayN = "th";
  switch (day) {
    case 1:
      dayN = "st";
      break;
    case 2:
      dayN = "nd";
      break;
    case 3:
      dayN = "rd";
      break;
    default:
      dayN = "th";
  }
  var month = currentDate.getMonth() + 1;
  var year = currentDate.getFullYear();

  var days = [
    "Søndag",
    "Mandag",
    "Tirsdag",
    "Onsdag",
    "Torsdag",
    "Fredag",
    "Lørdag",
  ];
  const monthNames = [
    "januar",
    "februar",
    "marts",
    "april",
    "maj",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "december",
  ];
  $(".date-product_no").html(
    days[currentDateNew.getDay()] +
      ", " +
      day +
      " " +
      monthNames[currentDateNew.getMonth()]
  );

  if (hours > 13) {
    $(".date-product").html("imorgen.");
  } else {
    $(".date-product").html("idag.");
  }
}, 1000);
